import { render, staticRenderFns } from "./NewsDescription.vue?vue&type=template&id=e2cff8cc&scoped=true&"
import script from "./NewsDescription.vue?vue&type=script&lang=js&"
export * from "./NewsDescription.vue?vue&type=script&lang=js&"
import style0 from "./NewsDescription.vue?vue&type=style&index=0&id=e2cff8cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2cff8cc",
  null
  
)

export default component.exports